module.exports = __webpack_public_path__ + "static/media/3.19.401fbbf3.png";